import { Button, Col, Input, Select, Row, Checkbox } from "antd";
import { useNavigate } from "react-router-dom";
import useGet from "../../../global/hooks/useGet";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import SentIcon from "../../../assets/images/vectors/SentIcon";
import { HiArrowPath } from "react-icons/hi2";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { useAuthData } from "../../../providers/AuthProvider";
import FormToggleButton from "../../../global/components/inputWidgets/ButtonSwitch";
import { getUserRoles } from "../../../global/components/PrivateRoute";

export const AccountFilter = ({
  filter,
  handleFilterChange,
  handleFilter,
  handleReset,
  setShowModal,
  selectedRowKeys,
  setFilter,
  handleInvitation,
}) => {
  const { userData } = useAuthData();
  const { isSystemUser, isDealerUser, isOemUser } = getUserRoles(userData);
  const navigate = useNavigate();
  const optionUrl = `${process.env.REACT_APP_API_URL}/api/accounts/options/`;

  const {
    data: optionsData,
    loading: optionDataLoading,
    error: optionDataError,
  } = useGet(optionUrl);

  const modifiedDealer = getModifiedResponse(optionsData, "dealers");
  const modifiedCustomer = getModifiedResponse(optionsData, "customers");
  const modifiedType = getModifiedResponse(optionsData, "roles");
  const modifiedOems = getModifiedResponse(optionsData, "oems");

  const onSearch = (value) => {
    // console.log("search:", value);
  };

  const getToggleButtonLabel = () => {
    if (isSystemUser) {
      return "System Accounts";
    }
    if (isOemUser) {
      return "OEM Accounts";
    }
    if (isDealerUser) {
      return "Dealer Accounts";
    }
  };
  const getAccountTypeId = () => {
    if (isSystemUser) {
      return "1,2,3";
    }
    if (isOemUser) {
      return "4,5,6";
    }
    if (isDealerUser) {
      return "7,8,9";
    }
  };

  return (
    <div className="mb-4">
      <div className="mt-2">
        <Row gutter={[16, 16]}>
          {/* <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Input
              className="input_text_3 mr10 !h-full"
              name="AccountNo"
              placeholder="No"
              value={filter.AccountNo}
              onChange={handleFilterChange}
            />
          </Col> */}
          <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
            <Input
              className="input_text_3 mr10 h-full"
              name="UserId"
              placeholder="Username"
              value={filter.UserId}
              onChange={handleFilterChange}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
            <Input
              className="input_text_3 mr10 h-full"
              name="Email"
              placeholder="Email"
              value={filter.Email}
              onChange={handleFilterChange}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              showSearch
              placeholder="Account Type"
              optionFilterProp="label"
              value={
                filter.AccountType || typeof filter.AccountType === "number"
                  ? Number(filter.AccountType)
                  : null
              }
              onChange={(value) => setFilter({ ...filter, AccountType: value })}
              onSearch={onSearch}
              options={modifiedType}
              style={{ width: "100%" }}
              allowClear
            />
          </Col>
          {![4, 5, 7, 8, 10, 11].includes(userData?.role_value) && (
            <Col xs={24} sm={24} md={12} lg={8} xl={6}>
              <Select
                showSearch
                placeholder="OEM"
                optionFilterProp="label"
                value={
                  filter.OemNo || typeof filter.OemNo === "number"
                    ? Number(filter.OemNo)
                    : undefined
                }
                onChange={(value) => setFilter({ ...filter, OemNo: value })}
                onSearch={onSearch}
                options={modifiedOems}
                style={{ width: "100%" }}
                allowClear
              />
            </Col>
          )}
          {![7, 8, 10, 11].includes(userData?.role_value) && (
            <Col xs={24} sm={24} md={12} lg={8} xl={6}>
              <Select
                showSearch
                placeholder="Dealer"
                optionFilterProp="label"
                value={
                  filter.DealerNo || typeof filter.DealerNo === "number"
                    ? Number(filter.DealerNo)
                    : undefined
                }
                onChange={(value) => setFilter({ ...filter, DealerNo: value })}
                onSearch={onSearch}
                options={modifiedDealer}
                style={{ width: "100%" }}
                allowClear
              />
            </Col>
          )}
          {![10, 11].includes(userData?.role_value) && (
            <Col xs={24} sm={24} md={12} lg={8} xl={6}>
              <Select
                showSearch
                placeholder="Customer"
                optionFilterProp="label"
                value={
                  filter.CustomerNo || typeof filter.CustomerNo === "number"
                    ? Number(filter.CustomerNo)
                    : undefined
                }
                onChange={(value) =>
                  setFilter({ ...filter, CustomerNo: value })
                }
                onSearch={onSearch}
                options={modifiedCustomer}
                style={{ width: "100%" }}
                allowClear
              />
            </Col>
          )}
        </Row>
      </div>
      <div className="w-full overflow-x-auto">
        <div className="flex justify-between items-center mt-4 flex-nowrap min-w-[610px]">
          <div className="flex items-center">
            <Button
              type="primary"
              className="mr-2 w-[104px] h-[30px] font-medium"
              onClick={handleFilter}
            >
              <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
              Apply
            </Button>
            <Button className="reset-button" onClick={handleReset}>
              <HiArrowPath className="!text-[14px] font-medium" />
              Reset
            </Button>
            <Button
              type="primary"
              className="mr-2 -ml-2 w-[104px] h-[30px] font-medium"
              onClick={() => navigate("/account/add")}
            >
              <PlusOutlined />
              Add
            </Button>
            <Button
              type="primary"
              disabled={selectedRowKeys?.length === 0 ? true : false}
              className="mr-2 w-[104px] h-[30px] font-medium"
              onClick={() => {
                setShowModal(true);
              }}
            >
              <DeleteOutlined />
              Delete
            </Button>
            <Button
              type="primary"
              className="min-w-[104px] h-[30px] font-medium"
              onClick={handleInvitation}
              // disabled={selectedRowKeys?.length === 0 ? true : false}
            >
              <SentIcon />
              Send Invitation
            </Button>
          </div>
          {(isSystemUser || isOemUser || isDealerUser) && (
            <div>
              <Checkbox
                checked={filter?.AccountTypeIds !== undefined}
                onChange={(e) => {
                  const value = e.target.checked;
                  const newFilter = value
                    ? {
                        ...filter,
                        AccountTypeIds: getAccountTypeId(),
                      }
                    : (() => {
                        const { AccountTypeIds, ...rest } = filter;
                        return rest;
                      })();

                  setFilter(newFilter);
                  handleFilter(newFilter);
                }}
                className="ml-2"
              >
                {/* {getToggleButtonLabel()} */}
                My Accounts
              </Checkbox>
            </div>
          )}
          {/* <div>
            <Button
              type="primary"
              className="mr-2 w-[30px] h-[30px]"
              onClick={() => navigate("/account/add")}
            >
              <PlusOutlined />
            </Button>
            <Button
              type="primary"
              disabled={selectedRowKeys?.length === 0 ? true : false}
              className="w-[30px] h-[30px]"
              onClick={() => {
                setShowModal(true);
              }}
            >
              <DeleteOutlined />
            </Button>
          </div> */}
        </div>
      </div>
    </div>
  );
};
